/**
 * The backend url http://localhost
 */
export const __BACKEND_URL__ = process.env.REACT_APP_BACKEND_URL || '';

/**
 * The authorization are active or not
 */
export const __AUTHORIZATIONS__ = JSON.parse(process.env.REACT_APP_AUTHORIZATION || 'true');

/**
 * The production login is active or not
 */
export const __LOGIN_PRODUCTION__ = JSON.parse(process.env.REACT_APP_LOGIN_PRODUCTION || 'false');

/**
 * The backend url for pdnd module
 */
export const __PDND_API_URL__ = '/primami-mediation-pdnd/api/v1';

/**
 * The backend url for event manager module
 */
export const __EVENT_MANAGER_API_URL__ = '/primami-mediation-event-manager/api/v1';

/**
 * The backend url for event admin module
 */
export const __EVENT_ADMIN_API_URL__ = '/primami-operation-event-admin/api/v1';

/**
 * The backend url for authentication module
 */
export const __AUTH_API_URL__ = '/primami-operation-auth/api/v1';

/**
 *
 * The backend url for Operation-managment
 */
export const __OPERATION__MANAGEMENT__ = '/primami-operation-management/api/v1';

/**
 * The backend url for Electoral microservice
 */

export const __ELECTORAL_API_URL__ = '/primami-operation-elettorale/api/v1';

/**
 * The backend url for management module
 */
export const __MANAGEMENT_API_URL__ = `${__OPERATION__MANAGEMENT__}/profilazione`;

/**
 * The backend url for toponymy module
 */
export const __TOPONYMY_API_URL__ = '/primami-operation-toponomastica/api/v1';

/**
 * The backend url for municipality module
 */
export const __MUNICIPALITY_API_URL__ = '/primami-operation-comuni/api/v1';

/**
 * The backend url for person/anpr
 */
export const __PERSON_API_URL__ = '/primami-operation-persona/api/v1';

/**
 * The New backend url for person/anpr
 */
export const __PERSON_NEW_API_URL__ = '/primami-operation-anagrafe-persona/api/v1';

/**
 * The backend url for practice
 */
export const __PRACTICE_API_URL__ = '/primami-operation-pratiche/api/v1';

/**
 * The backend url for messi civic
 */
export const __CIVIC_API_URL__ = '/primami-operation-messicivici/api/v1';

/**
 * The backend url for cms
 */
export const __CMS_API_URL__ = '/primami-mediation-cms/api/v1';

/**
 * The backend url for cie
 */
export const __CIE_API_URL__ = '/primami-operation-cie/api/v1';

/**
 * The backend url for anpr
 */
export const __ANPR_PERSON_API_URL__ = `${__PERSON_API_URL__}/anpr`;

/**
 * The new backend url for anpr
 */
export const __ANPR_PERSON_NEW_API_URL__ = `${__PERSON_NEW_API_URL__}/anpr`;

/**
 * The backend url for certification microservice
 */
export const __CERTIFICATION_API_URL__ = '/primami-operation-certificazione/api/v1';

/**
 * The backend url for atti module
 */
export const __ACT_API_URL__ = '/primami-operation-atti/api/v1';

/**
 * The backend url for civil-status module
 */
export const __CIVIL_STATUS_API_URL__ = '/primami-operation-statocivile/api/v1/';

/**
 *
 * The backend url for Operation-event-admin
 */
export const __OPERATION__EVENT__ADMIN__ = '/primami-operation-event-admin/api/v1';

/**
 * The backend url for operation-batch
 */
export const __OPERATION__BATCH__ = '/primami-operation-batch/api/v1';

export const __SESSION_MANAGEMENT_STORAGE__ = process.env.REACT_APP_SESSION_MANAGEMENT || '';

/**
 * The backend url for military draft
 */
export const _MILITARY_DRAFT_CLASS_API_URL = '/primami-operation-leva/api/v1/classiLeva';
export const _MILITARY_DRAFT_LIST_API_URL = '/primami-operation-leva/api/v1/iscrizioni';
export const _MATRICULATION_ROLES_API_URL = '/primami-operation-leva/api/v1/ruoliMatricolari';
export const _PERSONA_RESOURCE_API_URL = '/primami-operation-leva/api/v1/persone';
export const _TYPE_LIST_API_URL = '/primami-operation-leva/api/v1/lookup';
export const _LEVA_PERSONA_ANPR_API_URL = '/primami-operation-persona/api/v1/leva-persona';
export const _STRANIERI_LEVA_API_URL = '/primami-operation-leva/api/v1/stranieri';

/**
 * The backend url for Municipal Messenger
 */
export const __MUNICIPAL_MESSENGER_API_URL__ = '/primami-operation-messi/api/v1';
export const _MUNICIPAL_MESSENGER_ACTS_LIST_API_URL = '/primami-operation-messi/api/v1/atti';
export const _MUNICIPAL_MESSENGER_INVESTIGATIONS_API_URL =
  '/primami-operation-messi/api/v1/accertamenti';
export const _MUNICIPAL_MESSENGER_INVESTIGATION_MEETINGS_API_URL =
  '/primami-operation-messi/api/v1/appuntamento-invito';
export const _MUNICIPAL_MESSENGER_TODO_INVESTIGATION_API_URL =
  '/primami-operation-messi/api/v1/agenda';
export const _MUNICIPAL_MESSENGER_MESSENGER_API_URL = '/primami-operation-messi/api/v1/messi';
export const _MUNICIPAL_MESSENGER_EXHIBITING_ENTITY_LIST_API_URL =
  '/primami-operation-messi/api/v1/enti';
export const _MUNICIPAL_MESSENGER_GROUPS_LIST_API_URL =
  '/primami-operation-messi/api/v1/raggruppamenti';
export const _MUNICIPAL_MESSENGER_ACT_TYPE_LIST_API_URL =
  '/primami-operation-messi/api/v1/tipo-atto';
export const _MUNICIPAL_MESSENGER_TOPONYMY_LIST_API_URL =
  '/primami-operation-messi/api/v1/toponomastica';
export const _MUNICIPAL_MESSENGER_OFFICE_LIST_API_URL = '/primami-operation-messi/api/v1/uffici';
export const _MUNICIPAL_MESSENGER_TYPES_LIST_API_URL = '/primami-operation-messi/api/v1/lookup';

/**
 * Acts as basename of all defined routes.
 */

export const __ROUTING_BASENAME__ = process.env.REACT_APP_ROUTING_BASENAME || '';

/**
 * Environment variable
 */
export const __ENVIRONMENT_TYPE__ = process.env.REACT_APP_ENVIRONMENT || '';
